import { CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { deleteData, fetchData, postData } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from "../../../context/popup";
import UploadFile from "../../Utils/UploadFile";
import ExternalapiOperationsFilterDialog from "./components/APIoperationsFilterDialog";
import { useLoading } from "../../../components/Loading";
import { FilterAlt } from "@mui/icons-material";

const APIoperationsList = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const currentPage = useSelector(
    (state) => state?.APIoperationsStore?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.APIoperationsStore?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.APIoperationsStore?.totalPages
  );

  const [isRefresh, setIsRefresh] = useState(false);
  const [apiOperations, setapiOperations] = useState([]);
  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
    isActive: "",
    apiOperationsId: "",
    protocolId: "",
    environmentId: "",
    authTypeId: "",
  });

  useEffect(() => {
    fetchAPIoperationsList();
  }, [isRefresh, currentPage, rowsPerPage, search]);

  //List API
  const fetchAPIoperationsList = async () => {
    setCircleLoading(true);
    try {
      let url = `/api-engine/api-operation?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;

      Object.entries(filterData).forEach(([key, value]) => {
        if (value !== "" && value != null) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      const response = await fetchData(url);

      if (response?.success) {
        setapiOperations(response?.data?.items);
        dispatch(setTotalPages(response?.data?.totalPages));
      } else {
        //throw error
        showSnackbar("Error Fetching External Api End Points List", "error");
      }
    } catch (error) {
      console.error("Error Fetching External Api End Points:", error);
      showSnackbar(error?.response?.data?.message || "Error Fetching External Api End Points List", "error");
    } finally {
      setCircleLoading(false);
    }
  };

  //bulk file upload api function
  const handleFileUploadSuccess = async (file) => {
    setFileUploading(true);
    setUploadSuccess(false);

    try {
      const formData = new FormData();

      formData.append("file", file);

      const result = await postData(`/api-engine/operation`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (result?.success) {
        setUploadSuccess(true);
        showSnackbar(result?.message, "success");
        setOpenUploadFileDialog(false);
        setClearFileOnSuccess(true);
        fetchAPIoperationsList();
      } else {
        setUploadSuccess(false);
        showSnackbar("Faiiled to upload file", "error");
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      console.error("Upload error:", error || errorMessage);
      showSnackbar(errorMessage, "error");
    } finally {
      setFileUploading(false);
    }
  };

  //delete api
  const handleDelete = async (row) => {
    try {
      const response = await deleteData(`/api-engine/api-operation-delete`, {
        ids: [row?.id],
      });
      setIsRefresh(!isRefresh);
      if (response?.success) {
        showSnackbar("External Api End Points deleted successfully", "success");
      } else {
        showSnackbar("Failed to delete External Api End Points", "error");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      showSnackbar(error?.response?.data?.message || "Error Deleting External Api End Points", "error");
    }
  };

  //Table Mapping
  const APIoperationsListTable = {
    columns: [
      {
        key: "sno",
        label: "S.No.",
        renderCell: (row) => row.sno,
      },
      {
        key: "apiRegistry",
        label: "API Registry",
        renderCell: (row) => row.apiRegistry,
      },
      {
        key: "apiCategory",
        label: "API Category",
        renderCell: (row) => row.apiCategory,
      },
      {
        key: "apiEndpoint",
        label: "API Endpoint",
        renderCell: (row) => row.apiEndpoint,
      },
      {
        key: "protocol",
        label: "Protocol",
        renderCell: (row) => row.protocol,
      },
      {
        key: "httpMethod",
        label: "HTTP Method",
        renderCell: (row) => row.httpMethod,
      },
      {
        key: "version",
        label: "Version",
        renderCell: (row) => row.version,
      },
      {
        key: "isActive",
        label: "Status",
        renderCell: (row) => (
          <span
            style={{
              color: row.isActive ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {row.isActive ? "Active" : "Inactive"}
          </span>
        ),
      },
    ],

    rows: apiOperations?.map((item, index) => ({
      id: item.id,
      sno: index + 1,

      //  Correct nested mappings
      apiRegistry: item.apiRegistry?.name ?? "-",

      apiCategory: item.apiCategory?.keyName ?? "-",

      apiEndpoint: item.endpoint?.id ?? "-", // no URL provided in API

      protocol: item.protocol?.keyName ?? "-",

      httpMethod: item.httpMethod?.keyName ?? "-",

      graphqlOperationType: item.graphqlOperationType?.keyName ?? "-",

      operationCode: item.operationCode ?? "-",

      pathTemplate: item.pathTemplate ?? "-",

      version: item.version ?? "-",

      isActive: item.isActive ?? false,
    })),
  };

  const handleAddNewapiOperations = () => {
    navigate(
      `/api-integration-engine/external-api-operations/external-api-operations-details`
    );
  };

  const actions = {
    edit: true,
    view: true,
    delete: true,

    onEdit: (row) => {
      navigate(
        `/api-integration-engine/external-api-operations/external-api-operations-details?pageType=edit&id=${row.id}`
      );
    },
    onView: (row) => {
      navigate(
        `/api-integration-engine/external-api-operations/external-api-operations-details?pageType=view&id=${row.id}`
      );
    },
    onDelete: (row) => handleDelete(row),
  };

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <DashboardLayout>
      <CardHeader
        title={
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Api Operations List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of Api Operations around the world.
              </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FilterAlt />}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                Filter
              </MaterialButton>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddNewapiOperations()}
              >
               Api Operations
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <CardContent>
        <Table
          columns={APIoperationsListTable?.columns}
          data={APIoperationsListTable?.rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Api Operations found"
          handleSearch={handleSearch}
        />
      </CardContent>
      <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={["csv", "xlsx"]}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
      />
      <ExternalapiOperationsFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
          setAnchorEl(null); // close popup
          fetchAPIoperationsList(); // call API after filter applied
        }}
      />
    </DashboardLayout>
  );
};

export default APIoperationsList;
